import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import { isUndefined, isObject } from '@rrc/utils'
import RouterConfig from '../config/router.config'

let routes: Array<RouteRecordRaw> = []

const layoutRouter: RouteRecordRaw = {
  path: '/',
  name: 'Home',
  component: () => import(/* webpackChunkName: "materials" */ '@/Layout/index.vue'),
  children: []
}
//   [
//   {
//     path: '/about',
//     name: 'about',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
//   }
// ]

// 加载全局路由
if (!isUndefined(RouterConfig.global)) {
  routes = routes.concat(RouterConfig.global)
}

if (!isUndefined(RouterConfig.tabs)) {
  layoutRouter.children = RouterConfig.tabs
}

routes.push(layoutRouter)

// 重定向
if (isObject(RouterConfig.redirect)) {
  routes.push(RouterConfig.redirect)
}
console.log(routes)

const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior () {
    return { top: 0 } // 表示页面滚到顶部
  },
  routes
})

export default router
